/**
* this displays the fund list
*
* Created by Paul on 9/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'

// component import
import {Link} from 'react-router-dom'
import AppButton from '../../components/AppButton/'
import SimpleLoader from '../../components/SimpleLoader/'

// Configurations
import constants from '../../constants'

import Button from '@material-ui/core/Button'
import MaterialLink from '@material-ui/core/Link'

// style import
import './style.scss'


class FundList extends Component {

    componentDidMount() {
        const { getFundsListData } = this.props
        getFundsListData()
    }

    saveFundSummary(fund) {
        const { setFundSummaryData } = this.props
        setFundSummaryData(fund)
    }

    render() {

        const { fundsListData, isLoading } = this.props
        
        const fundRows = fundsListData.map((fund, index) => {

                let events = (fund.unmatched_cash_events + fund.unmatched_business_events + fund.outstanding_corporate_action_count);

                let status = "";
                
                if (fund.fund_status === 'Active') {
                    status = <div className="funds-list--column fund"><MaterialLink component={Link} to={`/fund/${fund.member_id}`} onClick={() => this.saveFundSummary(fund)}>{ fund.fund_name }</MaterialLink></div>;
                }
                else if (fund.fund_status === 'Setup' || fund.fund_status === 'Review') {
                    status = <div className="funds-list--column fund"><MaterialLink component={Link} to={`/resume_fund/${fund.member_id}`}>{ fund.fund_name }</MaterialLink></div>;
                }
                else {
                    status = <div className="funds-list--column">{ fund.fund_name }</div>;
                }       

                return (
                    <div key={index} className="row">
                        <div className="funds-list--column-medium">{ fund.fund_code ? fund.fund_code : <span className="empty-cell-data">-</span> }</div>
                        { status }
                        <div className="funds-list--column-medium">{ fund.fund_status }</div>
                        <div className="funds-list--column-medium">{ events == 0 ? <span className="empty-cell-data">-</span> : events }</div>
                        <div className="funds-list--column-medium">{ fund.processed_to_date ? fund.processed_to_date : <span className="empty-cell-data">-</span> }</div>
                    </div>
                )
            }
        )

        return (
            
            <div className="main-container main-container__funds">

                <h3>Funds List</h3>

                <div className="funds-list">

                    <section>
                        <header>
                            <div className="funds-list--column-medium">Code</div>
                            <div className="funds-list--column">Name</div>
                            <div className="funds-list--column-medium">Status</div>
                            <div className="funds-list--column-medium">Actions</div>
                            <div className="funds-list--column-medium">Period Update</div>
                        </header>
                        
                        { isLoading == false && fundsListData.length == 0 &&
                            <div className="empty_row">
                                <div className="funds-list--column">No funds under administration</div>
                            </div>
                        }

                        { isLoading == false && fundsListData.length > 0 && fundRows }

                        { isLoading && 
                            <div className="empty_row">
                                <div className="funds-list--column">Loading ...</div>
                            </div>
                        }

                    </section>

                </div>

                {/* add fund button */}
                <div className="main-container__funds__add-fund-button">
                    <Button variant="contained" color="primary" component={Link} to="/create_fund">
                        Create New Fund
                    </Button>
                    <Button variant="contained" color="primary" className="pad_button" component={Link} to="/transition_fund">
                        Transition Existing Fund
                    </Button>
                </div>

            </div>
        )
    }
}

// define the prop types
FundList.propTypes = {
    isLoading: PropTypes.bool,
    fundsListData: PropTypes.array
}

const mapStateToPros = (state) => {
    return {
        isLoading: state.fundsSummaryState.isLoading,
        fundsListData: state.fundsSummaryState.fundsListData
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundsListData: action.getFundsListData,
        setFundSummaryData: action.setFundSummaryData,
    }
}


export default connect(mapStateToPros,mapDispatchToProps)(FundList)



// WEBPACK FOOTER //
// ./src/components/FundList/index.js